module.exports = __webpack_public_path__ + "assets/img/ps-4.46bd0217.png";